import { Target, Users, UserX, Star, AlertCircle } from 'lucide-react'
import LoopPage from '../../components/LoopPage'

const stakeholders = [
  { icon: Target, label: 'Target users', description: 'The people you think you serve. Test whether your hypothesis survives a real conversation.' },
  { icon: Users, label: 'Early customers', description: 'The people who said yes. Find out what made them say yes — and what almost made them say no.' },
  { icon: UserX, label: 'Lapsed users', description: 'The people who left. Surface why before assumption hardens into roadmap.' },
  { icon: Star, label: 'Champions', description: 'The people who refer you. Mine the language they use — it is your next ad copy.' },
  { icon: AlertCircle, label: 'Naysayers', description: 'The people who passed. The most valuable feedback you are not getting today.' },
]

export default function ValidationLoop() {
  return (
    <LoopPage
      h1="Build the right thing. Before you build it."
      subhead="Validate PMF, service-market fit, value prop, pricing, and positioning with real conversations — not a 1-to-5 scale."
      outerLoopSteps={['Hypothesize', 'Test', 'Learn', 'Pivot']}
      gapHeadline="Most 'validation' doesn't validate anything"
      gapBody="Founders survey 50 people and call it validation. The novel perspective — the customer who reframes the problem — never surfaces in a 1-to-5 scale. PrismScope runs the lean loop end-to-end: hypothesize, test with conversations that adapt, synthesize across stakeholders, and decide what to pivot, persevere, or kill."
      stakeholders={stakeholders}
      sampleRetro={{
        wentWell: 'Pricing held at $99/mo. Buyer language consistent on workflow pain. Champion segment articulates value in one sentence.',
        couldHaveBeenBetter: 'Value prop reads as a feature list, not an outcome. Onboarding friction at step 3 caused two of five test users to bounce.',
        whatsNext: 'Rewrite the landing-page hero in champion language. Rebuild step-3 onboarding before the next test cohort.',
      }}
      audienceCallouts={[
        { title: 'For solo founders and early-stage teams', body: 'Validate PMF, service-market fit, value prop, pricing, and messaging in days, not quarters. Build the next iteration smarter than the last.' },
        { title: 'For venture studios and corporate innovation arms', body: 'Run the same loop across every portfolio bet. Compare signal across companies. Decide which to double down on and which to kill faster.' },
      ]}
      trackingPrefix="validation-loop"
      seoTitle="Product-Market Fit Validation for Founders"
      seoDescription="Validate PMF, value prop, and pricing with real conversations — not a 1-to-5 scale. Built for early-stage founders, venture studios, and innovation arms."
      seoPath="/feedback-loops/validation"
    />
  )
}
